import dpsquare from '../../Images/Products/dpsquare.jpg'
import dpsquare1 from '../../Images/Products/dpsquare1.jpg'
import dpsquare2 from '../../Images/Products/dpsquare2.jpg'
import dppipe from '../../Images/Products/dppipe.jpg'
import dppipe1 from '../../Images/Products/dppipe1.jpg'
import dppipe2 from '../../Images/Products/dppipe2.jpg'
import dpangle from '../../Images/Products/dpangle.jpg'
import dpangle1 from '../../Images/Products/dpangle1.jpg'
import dpangle2 from '../../Images/Products/dpangle2.jpg'
import dpflat from '../../Images/Products/dpflat.jpg'
import dpflat1 from '../../Images/Products/dpflat1.jpg'
import dpflat2 from '../../Images/Products/dpflat2.jpg'
import dpsteel from '../../Images/Products/dpsteel.jpg'
import dpsteel1 from '../../Images/Products/dpsteel1.jpg'
import dpsteel2 from '../../Images/Products/dpsteel2.jpg'
import dptrade from '../../Images/Products/dptrade.jpg'
import dptrade1 from '../../Images/Products/dptrade1.jpg'
import dptrade2 from '../../Images/Products/dptrade2.jpg'
import dpmesh from '../../Images/Products/dpmesh.jpg'
import dpmesh1 from '../../Images/Products/dpmesh1.jpg'
import dpmesh2 from '../../Images/Products/dpmesh2.jpg'
import dpsheet from '../../Images/Products/dpsheet.jpg'
import dpsheet1 from '../../Images/Products/dpsheet1.png'
import dpsheet2 from '../../Images/Products/dpsheet2.png'
import dptwist1 from '../../Images/Products/dptwist1.jpg'
import dptwist2 from '../../Images/Products/dptwist2.jpg'
import dptwist from '../../Images/Products/dptwist.png'





const product_images = {
    'dpsquare': dpsquare,
    'dpsquare1': dpsquare1,
    'dpsquare2': dpsquare2,
    'dppipe': dppipe,
    'dppipe1': dppipe1,
    'dppipe2': dppipe2,
    'dpangle': dpangle,
    'dpangle1': dpangle1,
    'dpangle2': dpangle2,
    'dpflat': dpflat,
    'dpflat1': dpflat1,
    'dpflat2': dpflat2,
    'dpsteel': dpsteel,
    'dpsteel1': dpsteel1,
    'dpsteel2': dpsteel2,
    'dptrade': dptrade,
    'dptrade1': dptrade1,
    'dptrade2': dptrade2,
    'dpmesh': dpmesh,
    'dpmesh1': dpmesh1,
    'dpmesh2': dpmesh2,
    'dpsheet': dpsheet,
    'dpsheet1': dpsheet1,
    'dpsheet2': dpsheet2,
    'dptwist': dptwist,
    'dptwist1': dptwist1,
    'dptwist2': dptwist2,
}



export {product_images}